import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "core/store/store";
import {
  ReduxStateProps,
  PublicProps,
  ThemeManagerComponent,
} from "./component";

function mapStateToProps(state: RootState): ReduxStateProps {
  return {
    theme: state.userSettingsStore!.theme,
  };
}

export const ThemeManager: React.FunctionComponent<PublicProps> = connect(
  mapStateToProps,
)(ThemeManagerComponent);
